export const name = 'rnChatService';
export default function rnChatService($q, $log, $filter, rnRegistry, rnHttp, rnRecordFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  const chatServiceName = 'chat_service';
  const chatServiceRoot = 'room';
  const dateFormat = 'yyyy-MM-dd HH:mm:ssZ';
  const portalService= 'sms_portal';

  var service = {
    getChatrooms: getChatrooms,
	  getChatroom: getChatroom,
	  getOrgUsers: getOrgUsers,
    startChat: startChat,
    sendMessage: sendMessage,
	  getMessage: getMessage,
	  unsubscribe: unsubscribe,
	  getMessages: getMessages,
	  getChatroomByEntity: getChatroomByEntity,
    addRemoveCurrentUser: addRemoveCurrentUser,
	  loadMoreChats: loadMoreChats,
	  createRoomRecord: createRoomRecord,
	  chatHalRequest: chatHalRequest
  };

  return service;

  ////////////////

  function getOrgUsers(link, params) {
    let config = {};
	  config.params = params;

    return chatHalRequest(link, null, config)
      .then(function(resp) {
        return $q.resolve(resp.data);
      });
  }

  function getChatrooms() {
    let config = {};
    var today = new Date();
    today.setHours(0, 0, 0, 0);
	  config.params = {timestamp : today.toISOString().replace(/T/, ' ').replace(/\..+/, '')};
    var proxyServicePromise = rnRegistry.getUrl(chatServiceName);

    return proxyServicePromise
      .then(function (url) {
        var link ={};
        link.href = url;
        link.op = 'GET';
        return rnHttp.halRequest(link, null, config)
          .then(function(resp) {
            let chatData = resp.data;
            let categories = _.map(chatData.categories, createCategoryRecord);
            chatData.categories = categories;
            return $q.resolve(chatData);
          });
      });
  }

  function startChat(chatroom, link) {
    let config = {};

    return chatHalRequest(link, chatroom, config)
      .then(function(resp) {
        let chatroom = createRoomRecord(resp.data);
        return $q.resolve(chatroom);
      });
  }

  function sendMessage(message, link) {
    let config = {};

    return chatHalRequest(link, message, config)
      .then(function(resp) {
        return $q.resolve(resp.data);
      });
  }

  function unsubscribe(link) {
    let config = {};
    return chatHalRequest(link, null, config);
  }

  function getMessage(url, updateMsgRead) {
	  let link = {};
	  link.op = 'GET';
	  link.href = url;
    let config = {};
	  if(updateMsgRead){
	    config.params = {updateMsgRead : true};
	  }

    return chatHalRequest(link, null, config)
      .then(function(resp) {
        return $q.resolve(resp.data);
      });
  }

  function getMessages(link) {
    let config = {};

    return chatHalRequest(link, null, config)
      .then(function(resp) {
        return $q.resolve(resp.data);
      });
  }

  function getChatroom(url) {
	  let link = {};
	  link.op = 'GET';
	  link.href = url;
    let config = {};

    return chatHalRequest(link, null, config)
      .then(function(resp) {
        let chatroom = createRoomRecord(resp.data);
        return $q.resolve(chatroom);
      });
  }

  function getChatroomByEntity(entityId) {
	  let link = {};
	  link.op = 'GET';
    let config = {};
	  var proxyServicePromise = rnRegistry.getUrl(chatServiceName);

    return proxyServicePromise
      .then(function (url) {
        link.href = url + chatServiceRoot + "/entity/" + entityId;
        return rnHttp.halRequest(link, null, config)
          .then(function(resp) {
            let chatroom = createRoomRecord(resp.data);
            return $q.resolve(chatroom);
          });
      });
  }

  function createCategoryRecord(data) {
    let category = rnRecordFactory.create(data);
	  let roomRecords = _.map(category.rooms, createRoomRecord);
	  category.rooms = roomRecords;

    return category;
  }

  function createRoomRecord(data) {
    let room = rnRecordFactory.create(data);
    room.internal.idName = 'chatId';

    return room;
  }

  function addRemoveCurrentUser(link) {
    let config = {};
    return chatHalRequest(link, null, config)
      .then(function(resp) {
        let chatroom = createRoomRecord(resp.data);
        return $q.resolve(chatroom);
      });
  }

  function loadMoreChats(link) {
    let config = {};
    return chatHalRequest(link)
      .then(function(resp) {
        let category = resp.data;
        let categoryRecord = createCategoryRecord(category);
        return $q.resolve(categoryRecord);
      });
  }

  function chatHalRequest(link, data, config) {
	  let newLink = angular.copy(link);
    return appendServer(newLink.href)
      .then(function(href) {
        newLink.href = href;

        return rnHttp.halRequest(newLink, data, config);
      });
  }

  function appendServer(path) {
    return rnRegistry.getUrl(portalService, path);
  }
}
